import React, { Component } from "react";
import formStyle from '../../styles/form.module.css';
import styles from "../Login/Login.module.css";
import PropTypes from "prop-types";
import type from "../../types";


type LabelFormsType = {
    label: string,
    inputType: KeysType,
    value: string,
    type: string,
    placeholder: string,
    handleInput: (KeysType, string) => void,
    props?: any,
};

class Autocomplete extends Component<LabelFormsType> {
    static propTypes = {
        suggestions: PropTypes.instanceOf(Array)
    };

    static defaultProps = {
        suggestions: []
    };

    constructor(props) {
        super(props);

        this.state = {
            // The active selection's index
            activeSuggestion: 0,
            // The suggestions that match the user's input
            filteredSuggestions: [],
            // Whether or not the suggestion list is shown
            showSuggestions: false,
            // What the user has entered
            userInput: ""
        };
    }

    onChange = e => {
        const { suggestions } = this.props;
        const userInput = e.currentTarget.value;

        // Filter our suggestions that don't contain the user's input
        const filteredSuggestions = suggestions.filter(
            suggestion =>
                suggestion.toLowerCase().indexOf(userInput.toLowerCase()) > -1
        );

        this.setState({
            activeSuggestion: 0,
            filteredSuggestions,
            showSuggestions: true,
            userInput: e.currentTarget.value
            },
            function(){
                this.props.updateTextCB(this.state.userInput);
            }
        );



    };

    onClick = e => {


        this.setState({
            activeSuggestion: 0,
            filteredSuggestions: [],
            showSuggestions: false,
            userInput: e.currentTarget.innerText
        });

        this.props.updateTextCB(e.currentTarget.innerText);
    };

    onKeyDown = e => {
        const { activeSuggestion, filteredSuggestions } = this.state;

        // User pressed the enter key
        if (e.keyCode === 13) {
            this.setState({
                activeSuggestion: 0,
                showSuggestions: false,
                userInput: filteredSuggestions[activeSuggestion]
            });
            this.props.updateTextCB(filteredSuggestions[activeSuggestion]);
        }
        // User pressed the up arrow
        else if (e.keyCode === 38) {
            if (activeSuggestion === 0) {
                return;
            }

            this.setState({ activeSuggestion: activeSuggestion - 1 });
        }
        // User pressed the down arrow
        else if (e.keyCode === 40) {
            if (activeSuggestion - 1 === filteredSuggestions.length) {
                return;
            }

            this.setState({ activeSuggestion: activeSuggestion + 1 });
        }

    };

    handleInput = (type: KeysType, value: string) => {

        this.setState(
            {[type]: value},
        );

    };

    render() {
        const {
            onChange,
            onClick,
            onKeyDown,
            state: {
                activeSuggestion,
                filteredSuggestions,
                showSuggestions,
                userInput
            }
        } = this;

        let suggestionsListComponent;

        if (showSuggestions && userInput) {
            if (filteredSuggestions.length) {
                suggestionsListComponent = (
                    <ul className={styles.suggestions}>
                        {filteredSuggestions.map((suggestion, index) => {
                            let className;

                            // Flag the active suggestion with a class
                            if (index === activeSuggestion) {
                                className = "suggestion-active";
                            }

                            return (
                                <li className={`${className} ${styles.suggestionsItem}`} key={suggestion} onClick={onClick}>
                                    {suggestion}
                                </li>
                            );
                        })}
                    </ul>
                );
            } else {
                suggestionsListComponent = (
                    <div className="no-suggestions">
                        {/*<em>No suggestions, you're on your own!</em>*/}
                    </div>
                );
            }
        }

        return (
            <label className={`
              ${formStyle.label}
              ${styles.label}
              ${this.props.className}
            `}>
                <input
                    // onSomething={(e) => this.props.updateTextCB(e.target.value)}
                    className={`${formStyle.input} ${styles.autocompleteJsInput}`}
                    required
                    type={'text'}
                    placeholder={this.props.label + '*'}
                    onChange={onChange}
                    // onInput={}
                    onKeyDown={onKeyDown}
                    value={userInput}
                />
                {suggestionsListComponent}
            </label>
        );
    }
}

export default Autocomplete;



// WEBPACK FOOTER //
// ./src/components/Register/Autocomplete.js